import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
interface WorkstreamBannerOverlayProps {
  isNetworkBanner: boolean;
}
function WorkstreamBannerOverlay(t0) {
  const $ = _c(11);
  const {
    isNetworkBanner
  } = t0;
  const t1 = isNetworkBanner ? "bg-primary-foreground/40" : "bg-popover";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("absolute -right-94 -bottom-33 size-112 rounded-full blur-[50px] transition-all duration-300 ease-in-out", "sm:-right-32 sm:-bottom-88", "lg:-right-10", "xl:top-32 xl:-right-7", "2xl:right-20 2xl:-bottom-97", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <div className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isNetworkBanner ? "bg-primary-foreground/40" : "bg-popover";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("absolute -top-25 -left-23 size-50 rounded-full blur-[50px] transition-all duration-300 ease-in-out", "md:-top-17 md:-left-22", "lg:-left-10", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <div className={t5} />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <div className="absolute inset-0 z-10">{t3}{t6}</div>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
export { WorkstreamBannerOverlay };